<template>
    <button>Get Started For Free</button>
</template>
<script>
export default {
    name:'MyButton',
}
</script>

<style scoped>
button{
    background-color: hsl(322, 100%, 66%);
    border-style: none;
    padding: .8rem 2.8rem ;
    border-radius: 2rem;
    color: white;
    font-weight: 700;
}
</style>